import { axiosPost } from '@/api/AxiosApi';
// 유저가입
type createUserProps = {
  email: string;
  user_pw: string;
  auth_num: string;
  terms_type: string[];
  lang: 'KO' | 'EN';
};

export const createUser = async (aData: createUserProps) => {
  const payload = {
    path: '/v1/users',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
// 핀번호 등록
type registerPinProps = {
  pin: string;
};
export const registerPin = async (aData: registerPinProps) => {
  const payload = {
    path: '/v1/auth/register',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

type createSnsUserProps = {
  email: string,
  terms_type: string[]
}
export const createSnsUser = async (aData: createSnsUserProps) => {
  const payload = {
    path: '/v1/auth/snsRegister',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
}